module.exports = __webpack_public_path__ + "static/4-714afac31144a6797ce0286195929b5c.jpg";